import { Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { WHITE, YELLOWMONEDD } from "../../../constants/colors";
import { JWTToken } from "../../vendas/listaDeVendas/components/SalesList";
import jwt_decode from "jwt-decode";
import ExtratoApi from "../../../services/ExtratoAPI";
import moment from "moment";
import { useEffect, useState } from "react";
import { dateForAPI } from "../../../constants/dataFormat";
import { useRecoilState } from "recoil";
import { customColors } from "../../../atoms/customColors";

export default function CardSaldo() {
  const yellow = "#FBC500";
  const [colors] = useRecoilState(customColors);
  const todayMorning = moment()
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS");
  const todayNight = moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS");
  const token = localStorage.getItem("token") || "";
  const [saldoCliente, setSaldoCliente] = useState(0);
  const [saldoFuturo, setSaldoFuturo] = useState(0);
  const tomorrow = moment()
    .startOf("day")
    .add(1, "day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS");
  const future = moment("2077-12-31").format(dateForAPI);

  // Decode token and extract idCliente and permissions
  let id = 0;
  let hasPermission42 = false;
  if (token && typeof token === "string" && token.includes(".")) {
    try {
      const decodedToken: JWTToken & { loginPermissoes?: string } =
        jwt_decode(token);
      id = decodedToken.idCliente || 0;

      // Try loginpermissoes (number[]) first
      if (decodedToken.loginpermissoes) {
        hasPermission42 = decodedToken.loginpermissoes.includes(42);
      }
      // Fallback to loginPermissoes (string)
      else if (decodedToken.loginPermissoes) {
        try {
          const loginPermissoes: number[] = JSON.parse(
            decodedToken.loginPermissoes
          );
          hasPermission42 = loginPermissoes.includes(42);
        } catch (parseError) {}
      }
    } catch (error) {}
  }

  async function getSaldo() {
    if (!id) return;
    try {
      const response = await ExtratoApi.getSaldo(
        1,
        100,
        todayMorning,
        todayNight,
        id
      );
      setSaldoCliente(
        response.data[0]
          ? response.data[0]?.saldoAnterior + response.data[0]?.saldoPeriodo
          : 0
      );
      const response2 = await ExtratoApi.getSaldo(1, 100, tomorrow, future, id);
      setSaldoFuturo(response2.data[0]?.saldoPeriodo || 0);
    } catch (error) {}
  }

  useEffect(() => {
    getSaldo();
  }, [id]);

  return (
    <Flex
      w={{ base: "92%", md: "80%" }}
      h={"100%"}
      flexDir="column"
      justifyContent={"space-evenly"}
      alignItems={"space-evenly"}
    >
      {/* uma coluna em tela estreita: com columns={2} fixo, os valores em
          moeda quebravam no meio ("R$ 1.234," / "56") em 4:3 */}
      <SimpleGrid
        columns={{ base: 1, sm: 2 }}
        p={{ base: 2, md: 4 }}
        spacingX={10}
        spacingY={2}
      >
        <Flex w={"100%"} h={"100%"} flexDir="column">
          <Text color={colors.WHITE} fontSize={"clamp(15px, 1.3vw, 22px)"} fontWeight={"bold"}>
            SALDO ATUAL
          </Text>
          <Text color={yellow} fontWeight="bold" fontSize={"clamp(20px, 1.8vw, 32px)"}>
            {hasPermission42
              ? "****"
              : saldoCliente
              ? saldoCliente.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              : "R$ 0,00"}
          </Text>
        </Flex>
        <Flex w={"100%"} h={"100%"} flexDir="column">
          <Text color={colors.WHITE} fontSize={"clamp(15px, 1.3vw, 22px)"} fontWeight={"bold"}>
            A RECEBER
          </Text>
          <Text color={yellow} fontWeight="bold" fontSize={"clamp(20px, 1.8vw, 32px)"}>
            {hasPermission42
              ? "****"
              : saldoFuturo
              ? saldoFuturo.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              : "R$ 0,00"}
          </Text>
        </Flex>
      </SimpleGrid>
    </Flex>
  );
}
